<template>
  <div class="benchmark-report" id="print_element">
    <div>
      <ReportDetailsHeader title="Сравнение с бенчмарком по отрасли" :reportType="'benchmark'" />
    </div>
    <div class="benchmark-report-main">
      <div>
        <EiGeneralScale
            :value="generalScoreDetails.generalValue"
            :compare-value="generalScoreDetails.compareValue"
            :main-label="reportDetails.groupName ?? ''"
            compare-label="Отраслевой ЭИ-профиль"
        />
      </div>
      <div>
        <EiBenchmarkPage
          :scores="scores"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/runtime-core";
import { useStore } from "vuex";
import GroupCards from "../charts/GroupCards.vue";
import BarChart from "../charts/BarChart.vue";
import DoughnutChart from "../charts/DoughnutChart.vue";
import Consultation from "./../charts/details/Consultation.vue";
import ReportDetailsHeader from "@/feature/analytics/report-parameters/ReportDetailsHeader.vue";
import EiBenchmarkPage from "@/components/Analytics/BenchmarkDetails.vue";
import EiGeneralScale from "@/components/Analytics/GeneralBenchmarkDetail.vue";

export default {
  components: {EiGeneralScale, EiBenchmarkPage, ReportDetailsHeader, GroupCards, BarChart, DoughnutChart, Consultation },
  name: "benchmark-report",
  setup() {
    const store = useStore();

    const print = () => window.print();

    const reportDetails = computed(() => {
      return store.state.analytics.currentReportDetails ?? {
        groupName: null,
        filterName: null,
        employeeCount: null,
        dateString: null,
      }
    })

    const employeeCountText = computed(() => {
      const count = reportDetails.value.employeeCount

      if (count === null || count === undefined || count === '') {
        return null
      }

      return `${count} сотрудников`
    });

    const reportData = computed(() => store.state.analytics.reportData);

    const scores = computed(() => {
      const data = reportData.value || {};

      const groupAverage = data.group?.average || {};
      const groupDetailing = data.group?.detailing || {};

      const industryAverage = data.industry?.average || {};
      const industryDetailing = data.industry?.detailing || {};

      const source = {
        ...groupAverage,
        ...groupDetailing,
      };

      const compareSource = {
        ...industryAverage,
        ...industryDetailing,
      };

      return Object.keys(source).reduce((acc, key) => {
        acc[key] = {
          value: Math.round(Number(source[key])),
          compareValue: Math.round(Number(compareSource[key])),
        };

        return acc;
      }, {});
    });

    const generalScoreDetails = computed(() => {
      const generalValue = reportData.value?.group?.general?.general_total;
      const compareValue = reportData.value?.industry?.general?.general_total;

      return {
        generalValue: generalValue ? Math.round(Number(generalValue)) : null,
        compareValue: compareValue ? Math.round(Number(compareValue)) : null,
      };
    });

    return {
      employeeCountText,
      reportDetails,
      print,
      scores,
      generalScoreDetails
    };
  },
};
</script>

<style lang="scss" scoped>
.benchmark-report-main {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
